import '../../modules/es.object.assign.js';
import { p as path$1 } from '../../internals/path.js';

var path = path$1;

var assign = path.Object.assign;

export { assign as a };
//# sourceMappingURL=assign.js.map
